module.exports = __webpack_public_path__ + "img/guardian_chainsheep.191ecb99.png";